/**
 * **Qué se le dice a la persona de un fallo del servidor** en las pantallas de vacaciones.
 *
 * El manejador común de la API (`GlobalDefaultExceptionHandler`, de `digitaltpm-core`) devuelve
 * los rechazos del módulo con su código —`CUSTOM_EXCEPTION`, `OPERATION_NOT_PERMITED`…— y un
 * texto escrito para quien está delante: «ya tienes vacaciones esos días», «el año siguiente se
 * pide desde el 1 de octubre». Pero un fallo que nadie ha previsto llega con el código `EXCEPTION`
 * y **el mensaje de la excepción de Java tal cual**: así llegó «No value present» al aviso rojo de
 * «Solicitar vacaciones» con unas fechas que no descontaban ningún día (#829).
 *
 * Está aquí y no copiado en cada `catch` porque lo enseñan diez sitios del módulo, y el que se
 * olvidara de la condición volvería a pintar texto interno. Y en `utils/` y no en el adaptador
 * porque los bancos de `scripts/` cargan de verdad lo que la pantalla importa de aquí, mientras
 * que el adaptador lo doblan: un método nuevo en él es un `TypeError` en el banco que no lo tenga.
 */

/** El código con el que el manejador común devuelve un fallo no previsto. */
export const FALLO_NO_PREVISTO = 'EXCEPTION';

/**
 * El mensaje del servidor si es un rechazo del módulo, y `porDefecto` —el texto propio de la
 * pantalla— si no hay mensaje o es el de un fallo no previsto.
 */
export default function mensajeDelServidor(e, porDefecto) {
  if (!e || !e.message || e.code === FALLO_NO_PREVISTO) return porDefecto;
  return e.message;
}
